import axios from 'axios'
import {Notification, Message} from 'element-ui'
import store from '@/store'; // 确保正确引入Vuex store

// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['Content-Type'] = 'image/png'
// const baseURL = process.env.VUE_APP_BASE_API
const baseURL = 'https://www.crosslingual.cn/' //wdemo51.wyoucms.cn
export const baseApi = 'https://www.crosslingual.cn';

// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: baseURL,
    // 超时
    timeout: 100000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
        // 将token添加到请求头 Bearer
        config.headers['Authorization'] = `${token}`;
    }

    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.status || 200;
        if (code === 401) {
            // 如果状态码是401，调用logout方法
            store.commit('logout');
            return Promise.reject(res.data.message || '身份验证失败，请重新登陆')
        } else if (code === 500) {
            console.log(res.data)
            Message({message: res.data.message || '连接服务器失败', type: 'error'})
            return Promise.reject(new Error(res.data.message || '连接服务器失败'))
            // return res.data
        } else if (code !== 200) {
            Notification.error({
                title: res.data.message || 'connect failed'
            })

            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error)
        let {
            message
        } = error;
        if (message == "Network Error") {
            message = "Abnormal backend interface connection";
        } else if (message.includes("timeout")) {
            message = "System interface request timeout";
        } else if (message.includes("Request failed with status code")) {
            message = "Interface " + message.substr(message.length - 3) + " abnormal";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)
// 导出service
export default service
